export class Messages {
   static MIN_VALUE = 'Must be min 3 characters at least';
   static NOT_HAIR = 'You are not allowed to use this category name';
}



